import { useEffect, useState, type RefObject } from "react"
import { fetchSVGText, mountInto, parseSVG, prepareSVG } from "../utils"

type Status = "idle" | "loading" | "ready" | "error"

type SVGMountState = {
	status: Status
	error: Error | null
}

export const useSVGMount = (
	svgUrl: string,
	containerRef: RefObject<HTMLElement | null>
): SVGMountState => {
	const [state, setState] = useState<SVGMountState>({ status: "idle", error: null })

	useEffect(() => {
		if (!svgUrl) return

		let cancelled = false

		fetchSVGText(svgUrl)
			.then((text) => {
				if (cancelled) return
				const svg = parseSVG(text)
				const container = containerRef.current
				if (!svg || !container) {
					throw new Error("Could not parse or mount SVG")
				}
				mountInto(container, prepareSVG(svg))
				setState({ status: "ready", error: null })
			})
			.catch((err: unknown) => {
				if (cancelled) return
				const error = err instanceof Error ? err : new Error(String(err))
				setState({ status: "error", error })
			})

		return () => {
			cancelled = true
		}
	}, [svgUrl, containerRef])

	return state
}
